import { withStyles, withTheme } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { DELETE_CLIENT_CONTRACT_SLA_FAILURE, GET_CLIENT_CONTRACT_SLA_FAILURE, POST_CLIENT_CONTRACT_SLA_FAILURE, UPDATE_CLIENT_CONTRACT_SLA_FAILURE } from '../../types';
import { deleteClientContractSLA, getClientContractSLA, postClientContractSLA, updateClientContractSLA } from '../../clients.actions';
import Spinner from 'modules/common/spinner.component';
import { enumColumn } from 'modules/common/enumTableColumn';

import CrudTableCard from 'modules/common/crudTableCard.component';

const styles = (theme) => {
  return {
    row: {
      backgroundColor: theme.palette.common.white,
    },
    accordionStyleContacts: {
      maxWidth: 1050,
    },
    inputGroup: {
      display: 'inline-flex',
      justifyContent: 'space-between',
    },
    root: {
      maxWidth: 170,
      marginRight: 10,
    },
    extRoot: {
      width: 115,
      marginRight: 10,
    },
    newRow: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 1050,
    },
  };
};

const ClientContractsSLATable = (props) => {

  const { clientId, enumerations } = props;

  const componentTypes =
    enumerations.clientSLAComponents && enumerations.clientSLAComponents.length > 0
      ? enumerations.clientSLAComponents.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const adjustedColumns = [
    { ...enumColumn('componentId', componentTypes), header: 'Component', type: 'dropdown-v2', options: componentTypes, size: 80, required: true, enableColumnDragging: false, enableColumnActions: false, enableResizing: false, tab: 1 },
    { accessorKey: 'goalTarget', header: 'Goal/Target', type: 'text', required: true, size: 60, enableColumnDragging: false, enableColumnActions: false, enableResizing: false, tab: 1 },
    { accessorKey: 'metricKPI', header: 'Metric/KPI', type: 'text', required: true, size: 60, enableColumnDragging: false, enableColumnActions: false, enableResizing: false, tab: 1  },
    { accessorKey: 'penalty', header: 'Penalty', type: 'text', required: true, size: 60, enableColumnDragging: false, enableColumnActions: false, enableResizing: false, tab: 1 },
    { accessorKey: 'notes', header: 'Notes', type: 'notes', size: 125, enableColumnDragging: false, enableColumnActions: false, enableResizing: false, tab: 1 },

  ];

  const updateRow = async (contractsSLA, values) => {
    const id = contractsSLA.original.clientSLAId;
    values.clientSLAId = id;
    values.clientRecordId = clientId;

    const resp = await props.updateClientContractSLA(values);
    if (resp.type === UPDATE_CLIENT_CONTRACT_SLA_FAILURE) {
      return false;
    } else {
      const getResp = await props.getClientContractSLA(props.clientId);
      if (getResp.type === GET_CLIENT_CONTRACT_SLA_FAILURE) {
        return false;
      } else {
        return true;
      }
    }
  };

  const createRow = async (values) => {
    values.clientRecordId = clientId;
    const resp = await props.postClientContractSLA(values);
    if (resp.type === POST_CLIENT_CONTRACT_SLA_FAILURE) {
      return false;
    } else {
      const getResp = await props.getClientContractSLA(props.clientId);
      if (getResp.type === GET_CLIENT_CONTRACT_SLA_FAILURE) {
        return false;
      } else {
        return true;
      }
    }
  };

  const deleteRow = async (contractsSLA) => {
    const id = contractsSLA.original.clientSLAId;
    const resp = await props.deleteClientContractSLA(id);
    if (resp.type === DELETE_CLIENT_CONTRACT_SLA_FAILURE) {
      return false;
    } else {
      const getResp = await props.getClientContractSLA(props.clientId);
      if (getResp.type === GET_CLIENT_CONTRACT_SLA_FAILURE) {
        return false;
      } else {
        return true;
      }
    }
  };

  const tabs = [{ header: 'SLA', order: 1, iconPath: ['fas', 'fa-clipboard'], multiTabComponent: false }];

  const summaries = [
    {
      adjustedColumns: adjustedColumns,
      rows: props.clientContractsSLA ? props.clientContractsSLA : [],
      addButtonText: 'Add Record',
      tab: 1,
      updateRow: updateRow,
      createRow: createRow,
      deleteRow: deleteRow,
      hideEdit: false,
      hideHeader: false,
    }
  ];

  return (
    <>
      {props.clientContractsSLALoading && <Spinner />}
      {!props.clientContractsSLALoading && <CrudTableCard tabs={tabs} summaries={summaries} numColumns={5} />}
    </>
  );
}; 

ClientContractsSLATable.propTypes = {
  classes: PropTypes.object.isRequired,
  clientContractsSLALoading: PropTypes.bool,
  clientId: PropTypes.number,
  formikProps: PropTypes.object.isRequired,
  internalUsers: PropTypes.array,
  postClientContractSLA: PropTypes.func,
  updateClientContractSLA: PropTypes.func,
  getClientContractSLA: PropTypes.func,
  deleteClientContractSLA: PropTypes.func,
  clientContractsSLA: PropTypes.array,
};

const mapStateToProps = (state) => {
  const clientContractsSLA = state.clients.clientsInfo[state.clients.currentClientId]?.clientDetails?.clientSLAs;
  const { clientContractsSLALoading } = state.clients;
  return {
    clientContractsSLA,
    clientContractsSLALoading,
  };
};
  
export default compose(
  withStyles(styles),
  withTheme,
  connect(mapStateToProps, {
    getClientContractSLA,
    deleteClientContractSLA,
    postClientContractSLA,
    updateClientContractSLA,
  }),
)(ClientContractsSLATable);